import initAnalytics from './init-analytics'
import getTracker from './get-tracker'
import {resolveClientId, getCachedClientId} from './get-client-id'

const config = window.addiesaas.google_analytics
const EventBus = window.addiesaas.$core.EventBus

function attachClientId(payload) {
    const clientId = getCachedClientId()
    if (clientId) {
        payload.ga_client_id = clientId
    }
}

function init() {
    const analytics = initAnalytics(config)

    if (analytics) {
        resolveClientId(config)

        EventBus.$on('cart.paying', attachClientId)
        EventBus.$on('customer.login', attachClientId)
        EventBus.$on('user.ping', attachClientId)
        EventBus.$on('user.profile', attachClientId)

        const tracker = getTracker(config)

        config.tracker = tracker

        if (tracker) {
            EventBus.$on('google-analytics.router.after-each', route => {
                const page = {
                    url: window.location.origin + route.fullPath,
                    path: route.path,
                }

                analytics.page(page)
            })

            EventBus.$on('cart.paid', order => tracker.trackPurchase(config, order, analytics))
            EventBus.$on('payment-processed', order => tracker.trackPurchase(config, order, analytics))
            EventBus.$on('product.viewed', payload => tracker.trackViewItem && tracker.trackViewItem(config, payload, analytics))
            EventBus.$on('cart.item.added', cartItem => tracker.trackAddToCart && tracker.trackAddToCart(config, cartItem, analytics))
            EventBus.$on('cart.checkout.begin', payload => tracker.trackBeginCheckout && tracker.trackBeginCheckout(config, payload, analytics))
            EventBus.$on('cart.paying', (payload, cartContext) => tracker.trackAddPaymentInfo && tracker.trackAddPaymentInfo(config, payload, cartContext, analytics))
        }
    }
}

if (config && config.is_active) {
    if (document.body) {
        init()
    } else {
        document.addEventListener('DOMContentLoaded', function () {
            init()
        })
    }
}
